import { Component, OnInit } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-empty-cache',
  templateUrl: './dialog-empty-cache.component.html',
  styleUrls: ['./dialog-empty-cache.component.css']
})
export class DialogEmptyCacheComponent implements OnInit {

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  onCloseDialog(): void {
    this.dialog.closeAll();
  }

}
